import type { ToastAction } from '../ui/AppToast.vue';

interface ToastApi {
  show: (msg: {
    text: string;
    action?: ToastAction;
    variant?: 'default' | 'danger';
    durationMs?: number;
  }) => number;
  dismiss: (id: number) => void;
}

function api(): ToastApi | null {
  return (window as Window & { __appToast?: ToastApi }).__appToast ?? null;
}

export function showToast(
  text: string,
  opts?: { action?: ToastAction; variant?: 'default' | 'danger'; durationMs?: number },
): number {
  return api()?.show({ text, ...opts }) ?? 0;
}

export function dismissToast(id: number): void {
  api()?.dismiss(id);
}
